var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-line",style:({ padding: `${_vm.top}px 0 ${_vm.bottom}px` })})
}
var staticRenderFns = []

export { render, staticRenderFns }